import React from "react";
import List from "@mui/material/List";
import styles from "./EntityList.module.css";
import ListSkeletonItem from "../EntityListItem/EntityListItemSkeleton";

interface EntityListSkeletonProps {
  grids: 1 | 2 | 3;
  itemsCount?: number;
  showSecondary?: boolean;
}

const EntityListSkeleton: React.FC<EntityListSkeletonProps> = ({
  grids,
  itemsCount = 5,
  showSecondary,
}) => {
  return (
    <List
      dense
      className={`${styles["container"]} ${grids ? styles[`container-${grids}`] : ""}`}
    >
      {Array.from({ length: itemsCount }).map((_, idx) => (
        <ListSkeletonItem key={idx} showSecondary={showSecondary} />
      ))}
    </List>
  );
};

export default EntityListSkeleton;
